/**
 * Tagalog/Filipino translations
 * Context: Hibachi catering service for home parties
 */
const tl = {
	nav: {
		home: 'HOME',
		california: 'CALIFORNIA',
		texas: 'TEXAS',
		florida: 'FLORIDA',
		menu: 'MENU',
		faq: 'TANONG',
		freeEstimate: 'Libreng Estimate',
		bookNow: 'MAG-BOOK',
		myBooking: 'Aking Booking',
	},
	seo: {
		homeDescription: 'Top Rated Hibachi At Home Experience. Dadalhin namin ang Hibachi Grill + Chef sa inyong backyard sa California, Texas, at Florida.',
	},
	hero: {
		title: 'HAPPY HIBACHI',
		tagline: '#1 Rated Hibachi sa Bahay',
		subtitle: 'Maranasan ang authentic na Japanese hibachi cooking sa inyong tahanan',
		description: 'Dadalhin ng mga propesyonal na chef ang excitement ng hibachi-style cooking diretso sa inyong backyard.',
		bookNow: 'Mag-Book Ngayon',
		freeEstimate: 'Libreng Estimate',
	},
	howItWorks: {
		title: 'Paano Gumagana',
		subtitle: 'Simpleng hakbang para sa perpektong hibachi party',
		step1: { title: 'Mag-Book Online', description: 'Piliin ang petsa, oras, at menu preferences' },
		step2: { title: 'Kami ang Maghahanda', description: 'Ang team namin ang bahala sa lahat ng ingredients at equipment' },
		step3: { title: 'Masiyahan sa Show', description: 'Panoorin ang chef mag-perform at tikman ang masarap na pagkain' },
		step4: { title: 'Kami ang Maglilinis', description: 'Magrelax habang kami ang bahala sa cleanup' },
	},
	menu: {
		title: 'Menu',
		subtitle: 'Sariwang sangkap, tunay na lasa',
		proteins: 'Main Dishes',
		sides: 'Sides at Appetizers',
		chicken: 'Manok',
		steak: 'Filet Mignon',
		shrimp: 'Hipon',
		salmon: 'Salmon',
		lobster: 'Lobster Tail',
		tofu: 'Tofu (Vegetarian)',
		scallops: 'Scallops',
		friedRice: 'Hibachi Fried Rice',
		noodles: 'Yakisoba Noodles',
		vegetables: 'Grilled Vegetables',
		salad: 'Ginger Salad',
		soup: 'Miso Soup',
		edamame: 'Edamame',
		includes: {
			salad: 'Fresh Salad',
			rice: 'Fried Rice',
			vegetables: 'Hibachi Vegetables',
			show: 'Laro at Palabas',
		},
		protein: {
			title: 'Pagpipilian ng Protein',
			included: 'Kasama Na',
		},
		upgrades: {
			title: 'Premium Upgrades',
			filet: 'Filet Mignon',
			lobster: 'Lobster',
			ribeye: 'Premium Ribeye',
			shrimp: 'Jumbo Shrimp',
			salmon: 'Wild Salmon',
			scallops: 'Large Scallops',
		},
		addons: {
			title: 'Dagdag na Pagkain',
			gyoza: 'Gyoza (12pcs)',
			edamame: 'Edamame',
			noodles: 'Noodles',
			thirdProtein: 'Ikatlong Protein',
		},
		coupon: {
			title: 'Espesyal na Coupon',
			subtitle: 'Para sa mga party mula Linggo hanggang Biyernes lamang!',
			email: 'Mag-email sa amin sa',
		},
		note: {
			outdoor: 'Nagluluto lang kami sa labas.',
			weather: 'Nagbibigay kami ng serbisyo kahit umuulan o maaraw, basta may tuyong lugar para makapagluto ang chef.',
		},
	},
	pricing: {
		title: 'Presyo',
		subtitle: 'Transparent na presyo, walang hidden fees',
		perPerson: 'bawat tao',
		minimum: 'Minimum 10 guests',
		includes: 'Kasama',
		includesList: {
			chef: 'Propesyonal na hibachi chef',
			ingredients: 'Lahat ng ingredients at supplies',
			equipment: 'Hibachi grill at equipment',
			setup: 'Setup at cleanup',
			show: 'Live cooking entertainment',
		},
		basic: { title: 'Basic Package', description: 'Para sa intimate gatherings' },
		premium: { title: 'Premium Package', description: 'Kumpletong hibachi experience' },
		deluxe: { title: 'Deluxe Package', description: 'Pinaka-luxury na dining' },
	},
	calendar: {
		available: 'Available',
		limited: 'Kaunti na lang',
		busy: 'Maraming booking',
		unavailable: 'Hindi available',
		today: 'Ngayon',
		prevMonth: 'Nakaraang buwan',
		nextMonth: 'Susunod na buwan',
		weekdays: {
			sun: 'Lin',
			mon: 'Lun',
			tue: 'Mar',
			wed: 'Miy',
			thu: 'Huw',
			fri: 'Biy',
			sat: 'Sab',
		},
		months: {
			january: 'Enero',
			february: 'Pebrero',
			march: 'Marso',
			april: 'Abril',
			may: 'Mayo',
			june: 'Hunyo',
			july: 'Hulyo',
			august: 'Agosto',
			september: 'Setyembre',
			october: 'Oktubre',
			november: 'Nobyembre',
			december: 'Disyembre',
		},
	},
	slider: {
		chef: 'Professional na Hibachi Chef',
		steak: 'Masarap na Hibachi Steak',
		shrimp: 'Amazing na Hibachi Shrimp',
		setup: 'Premium Hibachi Setup',
		presentation: 'Magandang Food Presentation',
	},
	booking: {
		title: 'I-Book ang Inyong Event',
		subtitle: 'Piliin ang inyong region para magsimula',
		selectRegion: 'Piliin ang Region',
		california: 'California',
		texas: 'Texas',
		florida: 'Florida',
		californiaTagline: 'Propesyonal na hibachi sa inyong bahay',
		texasTagline: 'Dala ang kahusayan ng hibachi sa Texas',
		floridaTagline: 'Sunshine state hibachi experience',
		servingAreas: 'Mga Lugar na Sineserbisyuhan',
		bookIn: 'Mag-Book',
		note: '* Hindi kailangan ng bayad. Tatawag kami para i-confirm.',
		quickBook: 'Quick Book:',
		summary: 'Booking Details',
		addToCalendar: 'Idagdag sa Calendar',
	},
	calculator: {
		title: 'Price Calculator',
		subtitle: 'Kumuha ng instant estimate para sa event mo',
		adults: 'Adults',
		kids: 'Mga Bata (under 12)',
		upgrades: 'Premium Upgrades',
		summary: 'Price Summary',
		subtotal: 'Subtotal',
		discount: 'Discount',
		total: 'Total',
		gratuity: 'Suggested Tip',
		grandTotal: 'Grand Total',
		bookNow: 'I-Book ang Event',
		note: '* Maaaring may travel fees depende sa location.',
		minimumNotice: 'Minimum 10 guests ang kailangan',
	},
	gallery: {
		title: 'Gallery',
		subtitle: 'Maranasan ang pagkakaiba ng Happy Hibachi',
		items: {
			chef: 'Professional Hibachi Chef',
			chefDesc: 'Professional Hibachi Chef sa Aksyon',
			grill: 'Hibachi Grill Setup',
			grillDesc: 'Premium Hibachi Grill Setup',
			steak: 'Hibachi Steak',
			steakDesc: 'Masarap na Hibachi Steak',
			vegetables: 'Hibachi Vegetables',
			vegetablesDesc: 'Fresh na Hibachi Vegetables',
			shrimp: 'Hibachi Shrimp',
			shrimpDesc: 'Amazing na Hibachi Shrimp',
			food: 'Food Presentation',
			foodDesc: 'Magandang Food Presentation',
		},
	},
	reviews: {
		title: 'Mga Review ng Customer',
		subtitle: 'Tingnan ang sinasabi ng customers tungkol sa Happy Hibachi',
		bookNow: 'I-Book ang Event',
		ctaTitle: 'Ready na Bang Gumawa ng Amazing Experience?',
		ctaText: 'Sumali sa daan-daang satisfied customers',
		rating: '5.0 Average Rating',
		verified: '100+ Verified Reviews',
		topRated: 'Top Rated na Serbisyo',
	},
	instagram: {
		title: 'Sundan ang Aming Journey',
		followUs: 'FOLLOW KAMI SA INSTAGRAM',
	},
	referral: {
		title: 'Mag-refer ng Kaibigan, Kumita ng Rewards',
		subtitle: 'I-share ang hibachi love at makakuha ng rewards!',
		step1Title: 'I-share ang Code',
		step1Desc: 'I-share ang referral code sa kaibigan',
		step2Title: 'Nag-book ang Kaibigan',
		step2Desc: '$30 off sa unang booking ng kaibigan',
		step3Title: 'May Reward Ka',
		step3Desc: '$50 credit para sa susunod na event',
		yourReward: 'Reward Mo',
		friendDiscount: 'Discount ng Kaibigan',
		getCode: 'Kunin ang Referral Code',
		emailPlaceholder: 'Ilagay ang email',
		invalidEmail: 'Valid na email ang kailangan',
		getCodeBtn: 'Kunin ang Code',
		successTitle: 'Ready na ang Code!',
		successDesc: 'Check ang email para sa code.',
		terms: '* Ang rewards ay applicable pagkatapos ng booking.',
	},
	newsletter: {
		title: 'Kumuha ng Exclusive Offers',
		subtitle: 'Mag-subscribe para sa special deals at tips!',
		placeholder: 'Ilagay ang email address',
		subscribe: 'Subscribe',
		invalidEmail: 'Ilagay ang valid na email',
		success: 'Salamat sa pag-subscribe!',
		error: 'May error. Subukan ulit.',
		privacy: 'Nirerespeto namin ang privacy mo.',
		benefit1: 'Exclusive discounts',
		benefit2: 'Party tips',
		benefit3: 'Menu updates',
	},
	myBooking: {
		title: 'Tingnan ang Aking Booking',
		subtitle: 'Ilagay ang email o phone number na ginamit sa pag-book',
		emailPlaceholder: 'Ilagay ang email address',
		phonePlaceholder: 'Ilagay ang phone number',
		search: 'Hanapin ang Booking',
		searching: 'Hinahanap...',
		results: 'Mga Resulta',
		noResults: 'Walang nakitang booking',
		error: 'Hindi nagtagumpay ang paghahanap, subukan ulit',
		bookingId: 'Booking ID',
		needHelp: 'Kailangan ng Tulong?',
		contactUs: 'Kung may tanong, huwag mag-atubiling makipag-ugnayan',
		pendingNote: 'Tatawag kami sa loob ng 2 oras para i-confirm',
		confirmedNote: 'Inaabangan namin kayo! Darating ang chef 30 minuto bago ang oras',
	},
	faq: {
		title: 'Mga Madalas na Tanong',
		subtitle: 'Lahat ng kailangan mong malaman',
		q1: 'Anong mga lugar ang sineserbisyuhan niyo?',
		a1: 'Kasalukuyan naming sineserbisyuhan ang California, Texas, at Florida. Makipag-ugnayan para i-verify kung sakop ang inyong specific location.',
		q2: 'Ilang guests ang kayang i-accommodate?',
		a2: 'Kailangan ng minimum 10 guests at hanggang 50 ang pwede. Para sa mas malalaking events, makipag-ugnayan para sa special arrangements.',
		q3: 'Ano ang kailangan kong i-provide?',
		a3: 'Kailangan lang ninyo i-provide ang space at ang mga bisita! Kami ang magdadala ng lahat ng equipment, ingredients, utensils, at kami ang bahala sa setup at cleanup.',
		q4: 'Gaano kaaga dapat mag-book?',
		a4: 'Inirerekumenda naming mag-book ng 2 weeks ahead para sa weekday events at 3-4 weeks para sa weekends. Mabilis maubos ang popular dates!',
		q5: 'Kaya ba ninyo i-accommodate ang dietary restrictions?',
		a5: 'Oo! May vegetarian options kami at kayang i-accommodate ang karamihan ng dietary restrictions. Ipaalam lang sa amin kapag nag-book.',
		q6: 'Ano ang cancellation policy niyo?',
		a6: 'Full refund kung kinansela 7+ days bago ang event. 50% refund kung 3-6 days notice. Walang refund kung less than 3 days notice.',
	},
	contact: {
		title: 'Makipag-ugnayan',
		subtitle: 'Nandito kami para tumulong',
		phone: 'Telepono',
		email: 'Email',
		hours: 'Business Hours',
		address: 'Service Areas',
	},
	footer: {
		description: 'Dinadala ang authentic na hibachi experience sa inyong tahanan',
		quickLinks: 'Quick Links',
		contact: 'Contact',
		followUs: 'Sundan Kami',
		copyright: '© 2024 Happy Hibachi. All rights reserved.',
		allRightsReserved: 'All rights reserved.',
		privacyPolicy: 'Privacy Policy',
		termsOfService: 'Terms of Service',
	},
	menuSelection: {
		title: 'PILIIN ANG TIPO NG PAGKAIN',
		subtitle: 'Lahat ng meals ay may kasamang kanin, hibachi vegetables, at special sauces',
		regular: {
			title: 'REGULAR',
			proteins: '2 proteins bawat tao',
			service: 'Kasama ang show, 90 min service',
		},
		premium: {
			title: 'PREMIUM',
			proteins: '2 premium proteins: Filet Mignon, Lobster, Scallops',
			service: 'Kasama ang show, 120 min service',
		},
		catering: {
			title: 'MALAKING EVENT',
			note: '50+ guests buffet style',
			proteins: '2 proteins bawat tao',
			service: 'Kasama ang shows, 3-4 hours service',
		},
		intimate: {
			title: 'INTIMATE PARTY',
			note: '5-7 guests',
			includes: 'Salads, gyoza, edamame, noodles + mixed proteins',
			substitution: 'Pwedeng palitan ang same-price proteins',
		},
	},
	form: {
		name: 'Buong Pangalan',
		namePlaceholder: 'Ilagay ang buong pangalan',
		email: 'Email Address',
		emailPlaceholder: 'Ilagay ang email',
		phone: 'Phone Number',
		phonePlaceholder: 'Ilagay ang phone number',
		date: 'Petsa ng Event',
		time: 'Preferred Time',
		guests: 'Bilang ng Guests',
		guestsHint: 'Minimum 10 guests',
		region: 'Piliin ang Region',
		eventType: 'Uri ng Event',
		message: 'Karagdagang Mensahe',
		messagePlaceholder: 'Sabihin sa amin ang tungkol sa event mo...',
		selectOption: 'Pumili ng option',
		selectDate: 'Pumili ng petsa',
		submit: 'I-Submit',
		submitting: 'Sinusubmit...',
		submitReservation: 'I-Submit ang Reservation',
		success: 'Nai-submit na ang Booking!',
		successMessage: 'Tatawag ang team namin sa loob ng 2 oras para i-confirm ang details.',
		weWillContact: 'Makikipag-ugnayan kami sa lalong madaling panahon para i-confirm ang details.',
		error: 'May nangyaring mali. Subukan ulit o tumawag direkta.',
		required: 'Kinakailangan',
		people: 'tao',
		noPaymentRequired: '* Hindi kailangan ng bayad ngayon. Tatawag kami para i-confirm.',
		invalidEmail: 'Maglagay ng valid na email address',
		invalidPhone: 'Maglagay ng valid na phone number',
		eventTypes: {
			birthday: 'Birthday Party',
			anniversary: 'Anniversary',
			graduation: 'Graduation',
			corporate: 'Corporate Event',
			holiday: 'Holiday Party',
			other: 'Iba Pa',
		},
		referralSource: 'Paano mo kami nakilala?',
		referral: {
			google: 'Google Search',
			friend: 'Referral ng kaibigan',
			event: 'Nakita sa event',
			other: 'Iba pa',
		},
		couponCode: 'Coupon Code',
		couponPlaceholder: 'Ilagay ang coupon code (opsyonal)',
		applyCoupon: 'I-apply',
	},
	estimate: {
		title: 'Kumuha ng Libreng Estimate',
		subtitle: 'Sabihin sa amin ang tungkol sa event mo at bibigyan ka namin ng custom quote',
		benefits: {
			title: 'Bakit Kami ang Piliin?',
			professional: 'Propesyonal na mga trained chefs',
			fresh: 'Sariwang high-quality ingredients',
			entertainment: 'Live cooking entertainment',
			cleanup: 'Kumpletong setup at cleanup',
			custom: 'Customizable menu options',
		},
	},
	bookNow: {
		title: 'I-Book ang Inyong Hibachi Party',
		subtitle: 'Punan ang form sa ibaba para i-reserve ang petsa',
		selectRegion: 'Una, piliin ang inyong region',
		formTitle: 'Event Details',
		pricing: 'Presyo mula $45/tao',
		note: 'Koko-confirm namin ang availability sa loob ng 2 oras',
	},
	notFound: {
		title: 'Hindi Nakita ang Page',
		description: 'Ang page na hinahanap mo ay hindi umiiral.',
		backHome: 'Bumalik sa Home',
	},
	common: {
		learnMore: 'Alamin Pa',
		viewAll: 'Tingnan Lahat',
		loading: 'Loading...',
		close: 'Isara',
		backToHome: 'Bumalik sa Home',
		total: 'Kabuuan',
		toBeConfirmed: 'Koko-confirm pa',
		specialOffer: 'Espesyal na Alok',
		goTo: 'Pumunta sa',
		previous: 'Nakaraan',
		next: 'Susunod',
	},
	topBar: {
		textUs: 'Text Kami',
		email: 'Email',
	},
	photoShare: {
		title: 'Ibahagi ang Mga Larawan',
		subtitle: 'Ibahagi ang iyong Hibachi experience at makakuha ng $25 off sa susunod na event!',
		option1Title: 'I-post sa Instagram',
		option1Desc: 'I-tag kami at gamitin ang #HappyHibachi',
		option2Title: 'Direktang I-upload',
		option2Desc: 'Ibahagi ang mga larawan sa amin',
		dropzone: 'I-drag at i-drop ang mga larawan dito o mag-click para mag-browse',
		maxFiles: 'Hanggang 5 photos',
		instagramPlaceholder: 'Ang iyong Instagram handle (opsyonal)',
		submit: 'I-submit ang Photos',
		submitting: 'Nag-a-upload...',
		successTitle: 'Na-submit na ang Mga Larawan!',
		successDesc: 'Salamat sa pagbabahagi! Ang $25 credit ay ilalapat sa susunod mong booking.',
		terms: '* Ang credit ay ilalapat pagkatapos ng photo review. Ang mga larawan ay maaaring ipakita sa aming social media.',
	},
	offer: {
		noTravel: 'Walang Travel Fee',
		within50: 'Sa loob ng 50 Milya',
		noHidden: 'Walang nakatagong bayad',
		exclusive: 'Eksklusibong diskwento',
		freeSetup: 'Libreng mesa at upuan',
		sunFri: 'Espesyal Linggo hanggang Biyernes!',
	},
	coupon: {
		minGuests: 'Minimum {{count}} guests ang kailangan',
		applied: 'Coupon na-apply! Diskwento: {{discount}}',
		invalid: 'Hindi valid ang coupon code',
		checkFailed: 'Nabigo ang verification',
		under15: 'kulang sa 15 tao',
		range15to25: '15-25 tao',
		range25to35: '25-35 tao',
		over35: '35+ tao',
	},
	privacy: {
		title: 'Patakaran sa Privacy',
		lastUpdated: 'Huling update: Enero 2026',
		section1: {
			title: '1. Impormasyong Kinokolekta Namin',
			intro: 'Kapag gumagamit ng mga serbisyo ng Happy Hibachi, maaaring kolektahin namin ang:',
			contact: 'Contact Information',
			contactDesc: 'Pangalan, email address, phone number',
			booking: 'Mga Detalye ng Booking',
			bookingDesc: 'Petsa ng event, oras, lokasyon, bilang ng guests',
			payment: 'Payment Information',
			paymentDesc: 'Secure na pinoproseso sa pamamagitan ng third-party providers',
			usage: 'Usage Data',
			usageDesc: 'Paano ka nakikipag-interact sa aming website',
		},
		section2: {
			title: '2. Paano Namin Ginagamit ang Iyong Impormasyon',
			item1: 'Iproseso at kumpirmahin ang mga booking',
			item2: 'Magpadala ng mga kumpirmasyon at paalala ng booking',
			item3: 'Sagutin ang iyong mga tanong',
			item4: 'Pagbutihin ang aming mga serbisyo',
			item5: 'Magpadala ng mga promotional offers (sa iyong pahintulot)',
		},
		section3: {
			title: '3. Pagbabahagi ng Impormasyon',
			intro: 'Hindi namin ibinebenta ang iyong personal na impormasyon. Maaari naming ibahagi ang impormasyon sa:',
			item1: 'Mga service provider na tumutulong sa aming operations',
			item2: 'Legal authorities kapag kinakailangan ng batas',
		},
		section4: {
			title: '4. Data Security',
			desc: 'Nagpapatupad kami ng naaangkop na mga security measures upang protektahan ang iyong personal na impormasyon. Gayunpaman, walang internet transmission na 100% secure.',
		},
		section5: {
			title: '5. Ang Iyong mga Karapatan',
			intro: 'May karapatan kang:',
			item1: 'I-access ang iyong personal data',
			item2: 'Humiling ng correction ng hindi tamang data',
			item3: 'Humiling ng deletion ng iyong data',
			item4: 'Mag-opt-out sa marketing communications',
		},
		section6: {
			title: '6. Cookies',
			desc: 'Gumagamit kami ng cookies upang mapabuti ang iyong browsing experience at suriin ang site traffic. Maaari mong kontrolin ang cookies sa pamamagitan ng iyong browser settings.',
		},
		section7: {
			title: '7. Makipag-ugnayan sa Amin',
			intro: 'Para sa mga tanong tungkol sa privacy:',
		},
	},
	terms: {
		title: 'Mga Tuntunin ng Serbisyo',
		lastUpdated: 'Huling update: Enero 2026',
		section1: {
			title: '1. Mga Serbisyo',
			desc: 'Nagbibigay ang Happy Hibachi ng mobile hibachi catering services. Dinadala namin ang mga propesyonal na chef at kagamitan sa iyong lokasyon upang maghanda ng authentic na hibachi meals.',
		},
		section2: {
			title: '2. Booking at Reservations',
			minimum: 'Minimum na Guests',
			minimumDesc: 'Kinakailangan ang minimum na 10 guests',
			confirmation: 'Confirmation',
			confirmationDesc: 'Ang mga booking ay kinukumpirma pagkatapos makipag-ugnayan ang aming team',
			deposit: 'Deposit',
			depositDesc: 'Maaaring kailanganin ang deposit upang ma-secure ang iyong petsa',
			finalCount: 'Final Count',
			finalCountDesc: 'Kailangang kumpirmahin ang guest count 48 oras bago ang event',
		},
		section3: {
			title: '3. Patakaran sa Pagkansela',
			sevenDays: '7+ araw na abiso',
			sevenDaysDesc: 'Buong refund ng deposit',
			threeSixDays: '3-6 na araw na abiso',
			threeSixDaysDesc: '50% ng deposit ang ibabalik',
			lessThanThree: 'Mas mababa sa 3 araw',
			lessThanThreeDesc: 'Hindi na maibabalik ang deposit',
			weather: 'Panahon',
			weatherDesc: 'Ire-reschedule namin nang walang bayad para sa masamang panahon',
		},
		section4: {
			title: '4. Mga Responsibilidad ng Customer',
			intro: 'Dapat magbigay ang mga customer ng:',
			item1: 'Sapat na outdoor space para sa pagluluto (minimum 10x10 feet)',
			item2: 'Access sa kuryente (standard outlet sa loob ng 50 feet)',
			item3: 'Mga mesa at upuan para sa guests',
			item4: 'Weather protection kung kinakailangan (tent, gazebo, atbp.)',
		},
		section5: {
			title: '5. Food Safety at Allergies',
			desc: 'Mangyaring ipaalam sa amin ang anumang food allergies o dietary restrictions sa oras ng booking. Bagama\'t nag-iingat kami, hindi namin magagarantiya ang isang ganap na allergen-free na kapaligiran dahil sa katangian ng hibachi cooking.',
		},
		section6: {
			title: '6. Pananagutan',
			desc: 'Ang Happy Hibachi ay may liability insurance. Gayunpaman, ang mga customer ay responsable sa kanilang mga guest at property. Hindi kami liable para sa mga aksidente na dulot ng guest behavior o pre-existing property conditions.',
		},
		section7: {
			title: '7. Service Area',
			intro: 'Kasalukuyang nagse-serve kami sa:',
			california: 'California (Los Angeles, San Diego, San Francisco, at mga karatig na lugar)',
			texas: 'Texas (Houston, Dallas, Austin, San Antonio, at mga karatig na lugar)',
			florida: 'Florida (Miami, Fort Lauderdale, at mga karatig na lugar)',
			travelFee: 'Maaaring may travel fees para sa mga lokasyon sa labas ng standard service area.',
		},
		section8: {
			title: '8. Mga Pagbabago sa Tuntunin',
			desc: 'Nakalaan sa amin ang karapatang baguhin ang mga tuntuning ito anumang oras. Ang patuloy na paggamit ng aming mga serbisyo ay nangangahulugan ng pagtanggap sa mga na-update na tuntunin.',
		},
		section9: {
			title: '9. Makipag-ugnayan',
			intro: 'Mga tanong tungkol sa mga tuntuning ito:',
		},
	},
	status: {
		pending: 'Pending',
		confirmed: 'Confirmed',
		completed: 'Completed',
		cancelled: 'Cancelled',
	},
	timeSlot: {
		afternoon: 'Hapon',
		evening: 'Gabi',
		night: 'Hatinggabi',
	},
	admin: {
		login: {
			title: 'Admin Login',
			subtitle: 'Ilagay ang password para magpatuloy',
			password: 'Password',
			loginButton: 'Mag-Login',
			loggingIn: 'Nagla-login...',
			invalidPassword: 'Mali ang password',
			loginFailed: 'Hindi nagtagumpay ang login',
			contactHelp: 'Makipag-ugnayan para sa tulong',
		},
		dashboard: {
			title: 'Admin Dashboard',
			logout: 'Mag-Logout',
		},
		stats: {
			totalBookings: 'Kabuuan',
			pending: 'Naghihintay',
			confirmed: 'Kinumpirma',
			completed: 'Tapos Na',
			cancelled: 'Kinansela',
			totalGuests: 'Kabuuang Guests',
		},
		tabs: {
			all: 'Lahat',
			pending: 'Naghihintay',
			confirmed: 'Kinumpirma',
			completed: 'Tapos Na',
			cancelled: 'Kinansela',
		},
		booking: {
			noBookings: 'Walang booking',
			noBookingsHint: 'Ang mga booking ay lalabas dito',
			guests: 'guests',
			booking: 'Booking',
			estimate: 'Estimate',
			contactInfo: 'Contact Info',
			eventDetails: 'Event Details',
			date: 'Petsa',
			time: 'Oras',
			notSpecified: 'Hindi tinukoy',
			region: 'Region',
			additionalNotes: 'Karagdagang Notes',
			updateStatus: 'I-Update ang Status',
			emailCustomer: 'Mag-Email',
			callCustomer: 'Tumawag',
		},
	},
};

export default tl;

